import { render, staticRenderFns } from "./MainExpert.vue?vue&type=template&id=5665f70c&scoped=true"
import script from "./MainExpert.vue?vue&type=script&lang=js"
export * from "./MainExpert.vue?vue&type=script&lang=js"
import style0 from "./MainExpert.vue?vue&type=style&index=0&id=5665f70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665f70c",
  null
  
)

export default component.exports